<template>
  <modal
    :name="name"
    height="auto"
    :width="width"
    ref="m"
    :shiftY="0.45"
    :scrollable="true"
    @before-open="beforeOpen"
    @before-close="close"
    class="dm-modal"
  >
    <div class="close" @click="$refs.m.close()">
      <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
        <path
          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
        ></path>
      </svg>
    </div>
    <div class="dm-modal-content">
      <slot class="flex flex-col items-center px-2" v-bind:params="params"></slot>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'DMModal',

  data() {
    return {
      params: false,
    };
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 400,
    },
  },

  methods: {
    close() {
      this.$emit('modal-close', this.name);
    },
    beforeOpen(d) {
      this.params = d.params;
    },
  },
};
</script>

<style lang="scss">
.dm-modal {
  padding: 0 1rem !important;
}

.dm-modal-content {
  @media screen and (max-width: 600px) {
    padding-bottom: 30px;
  }

  @supports (-webkit-touch-callout: none) {
    padding-bottom: 140px;
  }
}

.vm--overlay {
  background: rgba(0, 0, 0, 0.95) !important;
}

.vm--modal {
  background: transparent;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  left: 50% !important;
  top: 50% !important;
  bottom: 0;
  right: 0;
  transform: translate(-50%, -50%);
  justify-content: center;
  min-height: 100%;

  @media screen and (max-width: 600px) {
    padding-top: 20px;
    left: 50% !important;
    top: 0% !important;
    bottom: 0;
    right: 0;
    transform: translate(-50%, 0%);
  }

  .close {
    margin-left: auto;
    margin-right: 0;
    margin-bottom: 10px;
    cursor: pointer;

    svg {
      width: 20px;
    }
  }
}
</style>
